import { lazy } from "react";
import RequirePermission from "../components/RequirePermission/RequirePermission";

const ReportsLandingPage = lazy(() => import("../pages/private/Reports/ReportsLandingPage"));
const AgingReportPage = lazy(() => import("../pages/private/Reports/AgingReportPage"));
const ChargeOverviewPage = lazy(() => import("../pages/private/Reports/ChargeOverviewPage"));

// Helper to wrap route elements with permission checks
const guard = (element: React.ReactNode, permissions: string[]) => (
  <RequirePermission permissions={permissions}>
    {element}
  </RequirePermission>
);

export const reportRoutes = [
  { path: "reports", element: guard(<ReportsLandingPage />, ["ReadReports"]) },
  { path: "reports/aging", element: guard(<AgingReportPage />, ["ReadReports"]) },
  { path: "reports/charge-overview", element: guard(<ChargeOverviewPage />, ["ReadReports"]) },
];
